<div [ngClass]="layout === TableLayout.MODERN ? 'flex min-w-0 flex-wrap items-center gap-8 [&_button]:mb-0!' : 'm-b-24'">
  @for (btn of actions; track btn.name) {
    @if (!btn.hidden?.()) {
      @if (btn.customComponent) {
        <ng-container *ngComponentOutlet="btn.customComponent.component; inputs: btn.customComponent.inputs" />
      } @else {
        <button
          mat-flat-button
          [ngClass]="btn.class ?? ''"
          [class.m-r-8]="layout === TableLayout.CLASSIC"
          [class.m-b-8]="layout === TableLayout.CLASSIC"
          [ngStyle]="!btn.disabled?.(selection) ? { 'background-color': btn.color, color: btn.textColor ?? 'white' } : {}"
          [disabled]="btn.disabled?.(selection) ?? false"
          (click)="btn.action?.(selection)"
        >
          <span [ngClass]="layout === TableLayout.MODERN ? 'flex items-center gap-2' : 'd-flex align-items-center'">
            @if (btn.icon?.endsWith('.svg')) {
              <img
                [src]="'/assets/images/svgs/operators/' + btn.icon"
                [ngClass]="layout === TableLayout.MODERN ? 'h-5 w-5 shrink-0' : 'icon-20 m-r-8'"
                alt=""/>
            } @else if (btn.icon) {
              <i-tabler [ngClass]="layout === TableLayout.MODERN ? 'h-5 w-5 shrink-0' : 'icon-20 m-r-8'" [name]="btn.icon" />
            }
            <span>{{ (typeof btn.name === 'function' ? btn.name() : btn.name) | translate }}</span>
          </span>
        </button>
      }
    }
  }
</div>
